import React, { useEffect, useState } from 'react';
import { ChevronUp } from 'lucide-react';
import './FloatingWhatsApp.css';

export default function FloatingWhatsApp({
	phoneNumber = '21612345678',
	message = "Bonjour, je souhaite avoir plus d'informations.",
	tooltip = 'Contactez-nous sur WhatsApp',
	showAfter = 180,
}) {
	const [visible, setVisible] = useState(false);
	const [showTooltip, setShowTooltip] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			setVisible(window.scrollY > showAfter);
		};

		handleScroll();
		window.addEventListener('scroll', handleScroll, { passive: true });

		return () => window.removeEventListener('scroll', handleScroll);
	}, [showAfter]);

	const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
		message,
	)}`;

	return (
		<div className={`floating-wa-wrapper ${visible ? 'is-visible' : ''}`}>
			<div className={`floating-wa-tooltip ${showTooltip ? 'is-active' : ''}`}>
				{tooltip}
			</div>

			<a
				href={whatsappUrl}
				target='_blank'
				rel='noreferrer'
				className='floating-wa-button'
				aria-label='Ouvrir WhatsApp'
				onMouseEnter={() => setShowTooltip(true)}
				onMouseLeave={() => setShowTooltip(false)}
				onFocus={() => setShowTooltip(true)}
				onBlur={() => setShowTooltip(false)}>
				<span className='floating-wa-pulse'></span>

				<svg
					className='floating-wa-icon'
					viewBox='0 0 32 32'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'>
					<path
						d='M27.281 4.696C24.304 1.709 20.341 0.062 16.11 0.058C7.398 0.058 0.31 7.145 0.306 15.86C0.305 18.647 1.034 21.367 2.42 23.768L0 32L8.433 29.786C10.756 31.053 13.371 31.72 16.103 31.721H16.11C24.82 31.721 31.91 24.633 31.915 15.918C31.918 11.694 30.266 7.684 27.281 4.696ZM16.11 29.045H16.104C13.742 29.044 11.428 28.409 9.408 27.212L8.925 26.926L3.92 28.24L5.255 23.359L4.941 22.859C3.615 20.749 2.914 18.31 2.916 15.861C2.92 8.618 8.867 2.671 16.117 2.671C19.626 2.672 22.922 4.042 25.4 6.528C27.877 9.014 29.243 12.322 29.241 15.92C29.236 23.167 23.354 29.045 16.11 29.045ZM23.379 19.123C22.983 18.925 21.033 17.966 20.67 17.834C20.307 17.702 20.043 17.636 19.779 18.032C19.515 18.428 18.754 19.321 18.523 19.585C18.292 19.85 18.061 19.882 17.665 19.684C17.269 19.486 15.994 19.069 14.484 17.721C13.31 16.674 12.517 15.381 12.286 14.985C12.055 14.589 12.262 14.375 12.459 14.178C12.637 14 12.855 13.716 13.053 13.485C13.251 13.254 13.317 13.089 13.449 12.825C13.581 12.561 13.515 12.33 13.416 12.132C13.317 11.934 12.525 9.985 12.195 9.193C11.873 8.418 11.545 8.523 11.301 8.511C11.07 8.499 10.806 8.497 10.542 8.497C10.278 8.497 9.849 8.596 9.485 8.992C9.122 9.388 8.099 10.347 8.099 12.297C8.099 14.246 9.518 16.13 9.716 16.394C9.914 16.658 12.503 20.654 16.465 22.367C17.408 22.774 18.145 23.017 18.72 23.199C19.667 23.5 20.529 23.458 21.211 23.356C21.971 23.242 23.554 22.398 23.884 21.474C24.214 20.549 24.214 19.757 24.115 19.592C24.016 19.427 23.775 19.321 23.379 19.123Z'
						fill='currentColor'
					/>
				</svg>
			</a>

			<button
				type='button'
				className='floating-scroll-top'
				aria-label='Retour en haut'
				onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
				<ChevronUp size={18} />
			</button>
		</div>
	);
}
